import type { MapMarkerView } from './types';

const CHIP_CLASS = 'hotels-map__chip';
const PRICE_CLASS = 'hotels-map__chip-price';
const COUNT_CLASS = 'hotels-map__chip-count';

function getChipClassName(view: MapMarkerView): string {
  const modifiers = [CHIP_CLASS];

  if (view.kind === 'cluster') modifiers.push(`${CHIP_CLASS}_cluster`);
  if (view.selected) modifiers.push(`${CHIP_CLASS}_selected`);
  else if (view.containsSelected) modifiers.push(`${CHIP_CLASS}_contains-selected`);

  return modifiers.join(' ');
}

export function createChipElement(view: MapMarkerView): HTMLElement {
  const element = document.createElement('div');

  element.setAttribute('class', getChipClassName(view));
  element.dataset.testid = view.testid;

  const label = document.createElement('span');

  label.className = view.kind === 'cluster' ? COUNT_CLASS : PRICE_CLASS;
  label.textContent = view.kind === 'cluster' ? view.countLabel : view.priceLabel;
  element.append(label);

  return element;
}

export function patchChipElement(element: HTMLElement, previous: MapMarkerView, next: MapMarkerView): void {
  if (previous.kind !== next.kind) {
    const rebuilt = createChipElement(next);

    element.setAttribute('class', rebuilt.className);
    element.replaceChildren(...Array.from(rebuilt.childNodes));

    return;
  }

  element.setAttribute('class', getChipClassName(next));

  if (next.kind === 'pin' && previous.priceLabel !== next.priceLabel) {
    const price = element.querySelector(`.${PRICE_CLASS}`);

    if (price) price.textContent = next.priceLabel;
  }

  if (next.kind === 'cluster' && previous.countLabel !== next.countLabel) {
    const count = element.querySelector(`.${COUNT_CLASS}`);

    if (count) count.textContent = next.countLabel;
  }
}
